import React from 'react';
import { Typography, Paper, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Produccion: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Órdenes de Producción
      </Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={() => navigate('/inventario/produccion/nuevo')}
        sx={{ mb: 2 }}
      >
        Nueva Orden de Producción
      </Button>
      {/* Aquí irá la tabla de órdenes de producción */}
    </Paper>
  );
};

export default Produccion; 